import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import React from 'react';
import CommentBoxAvatar from '../../../../lego/CommentBoxAvatar';
import CommentBoxEditor from '../../../../lego/CommentBoxEditor';
import CommentBoxLayout from '../../../../layouts/CommentBoxLayout';
const EditorView = (_param)=>{
    var rest = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ React.createElement(CommentBoxLayout, {
        avatar: /*#__PURE__*/ React.createElement(CommentBoxAvatar, null),
        content: /*#__PURE__*/ React.createElement(CommentBoxEditor, rest)
    });
};
EditorView.displayName = 'EditorView';
export default EditorView;

//# sourceMappingURL=EditorView.js.map